import { c as _c } from "react/compiler-runtime";
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { circleCSS, svgCSS } from './LoadingIndicator.css';
import { box } from '@/uiPrimitives/layout/box';
import { pile } from '@/uiPrimitives/layout/pile';
export const LoadingIndicator = () => {
  const $ = _c(4);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div />;
    t1 = classes(pile({
      alignItems: "center",
      justifyItems: "center"
    }), box({
      size: "100%"
    }));
    t2 = classes(svgCSS, box({
      size: "3 | h1"
    }));
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <>{t0}<div className={t1}><svg className={t2} viewBox="25 25 50 50"><circle className={classes(circleCSS)} r="20" cy="50" cx="50" /></svg></div></>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};